import { useTranslation } from 'react-i18next';

export default function PostSubmitGuide() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('brochure.post.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('brochure.post.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('brochure.post.subtitleEn')}
          </p>
          <div className="gold-line mx-auto mb-5"></div>
          <p className="text-[15px] md:text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[600px] mx-auto">
            {t('brochure.post.lead')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {(['step1', 'step2', 'step3'] as const).map((step, idx) => (
            <div
              key={step}
              className="card-glow bg-background-100/60 border border-background-200/60 p-6 text-center relative"
            >
              <div className="w-8 h-8 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-500/[0.08]">
                <span className="text-accent-500 text-[14px] font-medium tracking-[0.06em]">{idx + 1}</span>
              </div>
              <h3 className="text-[16px] text-foreground-800 tracking-[0.04em] font-medium mb-2">
                {t(`brochure.post.${step}.title`)}
              </h3>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                {t(`brochure.post.${step}.desc`)}
              </p>
            </div>
          ))}
        </div>

        <p className="text-center text-[14px] text-foreground-400 tracking-[0.04em] mt-8">
          {t('brochure.alt.phoneHours')}{' '}
          <a href="tel:0368244086" className="text-accent-600 hover:text-accent-500 transition-colors">03-6824-4086</a>
        </p>
      </div>
    </section>
  );
}
